import { render } from "./CommentItem.vue?vue&type=template&id=3df39904&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=3df39904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df39904"]])

export default __exports__